import React from 'react';
import { motion } from 'framer-motion';
import { Flame, TrendingDown, Coffee, RotateCcw } from 'lucide-react';
const failures = [{
  icon: <Flame className="w-8 h-8 text-brand-orange" data-id="element-209" />,
  title: 'Cardio Prolongado',
  desc: 'El ejercicio cardiovascular prolongado eleva tu cortisol, lo que irónicamente bloquea la quema de grasa abdominal.'
}, {
  icon: <TrendingDown className="w-8 h-8 text-brand-orange" data-id="element-210" />,
  title: 'Dietas de Restricción',
  desc: "Las dietas de 'comer menos' ralentizan aún más tu metabolismo ya cansado, entrando en modo supervivencia."
}, {
  icon: <Coffee className="w-8 h-8 text-brand-orange" data-id="element-211" />,
  title: "Productos 'Light'",
  desc: 'Suelen estar cargados de edulcorantes que confunden a tu cerebro y disparan la ansiedad por el dulce.'
}, {
  icon: <RotateCcw className="w-8 h-8 text-brand-orange" data-id="element-212" />,
  title: 'Rutinas Obsoletas',
  desc: 'Seguir las mismas rutinas que hacías a los 30 ignora por completo la resistencia hormonal acumulada por décadas.'
}];
export function WhyFailed() {
  return <section className="py-20 px-4 bg-navy-900" data-id="element-213">
      <div className="max-w-6xl mx-auto" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-215">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-216">
            Por qué lo que intentaste{' '}
            <span className="text-gray-500 line-through decoration-red-500 decoration-4" data-id="element-217">
              no funcionó
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-218">
            No es falta de voluntad. Es que estabas usando las herramientas
            equivocadas para un cuerpo que ha cambiado.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-219">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-800 p-8 rounded-2xl border border-navy-700 hover:border-brand-orange/50 transition-colors group" data-id="element-220">
              <div className="bg-navy-900 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-221">
                {item.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-222">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-lg" data-id="element-223">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}